'use client';

import UniqueVisitsIndicator from '@/components/UniqueVisitsIndicator';

interface OrganizerLikeButtonProps {
  organizationId: string;
  className?: string;
  /** Unique visit count from backend – shown next to like button */
  uniqueVisits?: number | null;
}

export function OrganizerLikeButton({ className = '', uniqueVisits }: OrganizerLikeButtonProps) {
  return (
    <UniqueVisitsIndicator uniqueVisits={uniqueVisits} variant="inline" className={className} />
  );
}
